export const COOKIE_KEY = "authToken";
export const COOKIE_EXPIRATION_DAYS = 1; // 24 hours

/**
 * Determines if the app is running in a development environment.
 * Checks hostname or NODE_ENV (if available).
 */
const isDevEnvironment = () => (
    typeof window !== "undefined" && 
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
  );

/**
 * Sets a cookie with the given name, value, and expiration (in days).
 * Applies Secure flag only in non-dev environments (HTTPS required).
 * Always uses SameSite=Strict for security.
 */
export const setCookie = (name: string, value: string, days: number): void => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }

  const secureFlag = isDevEnvironment() ? "" : "; Secure";
  document.cookie = `${name}=${value || ""}${expires}; path=/${secureFlag}; SameSite=Strict`;
};

/**
 * Retrieves the value of a cookie by its name.
 * Returns null if the cookie is not found.
 */
export const getCookie = (name: string): string | null => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
  }
  return null;
};

/**
 * Erases a cookie by setting its Max-Age to a negative value.
 */
export const eraseCookie = (name: string): void => {
  document.cookie = name + "=; Max-Age=-99999999; path=/";
};